/** DEMOKRATIFABRIK RUNTIME VARIABLES */
import useEmitter from 'src/utils/emitter';
import { getCurrentRoute, getRouter } from 'src/services';
import { ref } from 'vue';
import useStoreService from './store.service';
const { setAssemblyIdentifier, setStageID } = useStoreService();
const emitter = useEmitter();
const instanceNr = ref(0);
const lastRouteString = ref(null); // the last visited url
const currentRouteString = ref(null); // the last visited url
/* Reload the page when redirecting to the same page */
const pushR = (route) => {
    const router = getRouter();
    const currentRoute = getCurrentRoute();
    const target = router.resolve(route).href;
    const current = router.resolve(currentRoute).href;
    if (target === current) {
        emitter.emit('reload');
    }
    else {
        router.push(route);
    }
};
// to enforce reload of page container!
const reload = () => {
    instanceNr.value += 1;
};
/* pushI: - Analog to push method:
However: It does nothing when redirecting to the same page.
Default push method raises an error.
*/
const pushI = (route) => {
    const router = getRouter();
    const currentRoute = getCurrentRoute();
    const target = router.resolve(route).href;
    const current = router.resolve(currentRoute).href;
    if (target !== current) {
        router.push(route);
    }
};
const gotoHome = () => {
    // console.log('AFTER LOGIN Home 5b');
    pushR({ name: 'home' });
};
const gotoProfile = () => {
    pushR({
        name: 'profile',
    });
    // pushR({ name: 'profile', query: { reload: 'true' } } as RouteLocationRaw);
};
const setLastRoute = (route) => {
    if (route) {
        const newRoute = {
            name: route.name,
            params: route.params,
        };
        lastRouteString.value = currentRouteString.value;
        if (route) {
            currentRouteString.value = newRoute;
        }
    }
};
const getAssemblyHomeRoute = (assembly) => {
    if (!assembly) {
        return {
            name: 'home',
        };
    }
    return {
        name: assembly.type,
        params: { assemblyIdentifier: assembly.identifier },
    };
};
const getAssemblyStartRoute = (assembly) => {
    if (!assembly) {
        return {
            name: 'home',
        };
    }
    return {
        name: `start__${assembly.type}`,
        params: {
            assemblyIdentifier: assembly.identifier,
            assemblyType: assembly.type,
        },
    };
};
const getAssemblyManageRoute = (assembly) => {
    if (!assembly) {
        return {
            name: 'home',
        };
    }
    return {
        name: `assembly_manage__${assembly.type}`,
        params: {
            assemblyIdentifier: assembly.identifier,
            assemblyType: assembly.type,
        },
    };
};
const gotoAssemblyHome = (assembly) => {
    const route = getAssemblyHomeRoute(assembly);
    pushR(route);
};
const gotoAssemblyStart = (assembly) => {
    const route = getAssemblyStartRoute(assembly);
    pushR(route);
};
const gotoAssemblyManage = (assembly) => {
    const route = getAssemblyManageRoute(assembly);
    pushR(route);
};
const clearSession = () => {
    setStageID(null);
    setAssemblyIdentifier(null);
};
export default function useRouterService() {
    // const currentRoute = getCurrentRoute();
    // const currentRouteMeta = computed(() => currentRoute?.meta);
    return {
        pushR,
        pushI,
        gotoProfile,
        gotoHome,
        reload,
        clearSession,
        setLastRoute,
        // currentRoute, // TODO: not used, right?
        gotoAssemblyManage,
        gotoAssemblyHome,
        gotoAssemblyStart,
        getAssemblyHomeRoute,
        getAssemblyManageRoute,
        instanceNr,
        lastRouteString,
        // currentRouteMeta,
    };
}
